<template>
  <!-- @TODO add gmf-context class -->
  <teleport to="body" v-if="isOpen">
    <div
      class="gmf-modal-overlay gmf-context"
      :class="{ 'gmf-invisible': isInvisible }"
      @click.prevent.stop
      @mouseup="closeFromOverlay"
      @touchdown.stop @mousedown.stop="setCloseFromOverlayEnabled"
      ref="overlay"
      data-gmf
      role="dialog"
      :aria-modal="true"
      :aria-labelledby="labelledby"
      :aria-describedby="describedby"
    >
        <div class="gmf-modal-body" @touchmove="cancelZoom" @click="stopPropagation" :class="computedClass">
          <button v-if="! disableCloseButton" class="gmf-modal-close-btn" @click="close" aria-label="Close">
            <Icon icon="modal-close" />
          </button>
          <slot />
        </div>
    </div>
  </teleport>
</template>

<script>
import modal from '@/utils/modal.js';
import bus from '@/utils/eventbus.js';
import modalStack from '@/utils/modalStack';
import Icon from '@/components/Icon.vue';

export default {
  props: ['display', 'modelValue', 'noLabel', 'stackModals', 'disableCloseButton', 'class', 'labelledby', 'describedby'],
  components: {
    Icon,
  },
  data () {
    return {
      isOpen: this.modelValue,
      isInvisible: true,
      closeFromOverlayEnabled: false,
    };
  },
  mounted () {
    bus.on('modal.close', this.close);
    if (this.isOpen) {
      this.onOpen();
    }
  },
  beforeUnmount () {
    bus.off('modal.close', this.close);
    modalStack.remove(this);
  },
  methods: {
    cancelZoom (ev) {
      if (ev.touches.length > 1) {
        ev.preventDefault();
      }
    },
    onOpen () {
      if (! this.stackModals) {
        modal.destroy();
      }
      // @TODO add self to modal.js, so that new modals will close this one

      setTimeout(() => {
        this.isInvisible = false;
      }, 10);

      modalStack.push(this);
    },
    setCloseFromOverlayEnabled (ev) {
      this.closeFromOverlayEnabled = ev.target === this.$refs.overlay;
    },
    stopPropagation (ev) {
      ev.stopPropagation();
      return false;
    },
    closeFromOverlay (ev) {
      if (! this.closeFromOverlayEnabled) {
        return;
      }
      if (ev.target !== this.$refs.overlay) {
        return;
      }
      this.close(ev);
    },
    open (ev) {
      this.$emit('open');
      this.isOpen = true;
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      this.$emit('update:modelValue', true);
      this.onOpen();
    },
    close (ev) {
      modalStack.remove(this);
      if (ev) {
        ev.stopPropagation();
        ev.preventDefault();
      }
      this.isInvisible = true;
      setTimeout(() => {
        this.isOpen = false;
        this.$emit('update:modelValue', false);
      }, 150);
    },
  },
  computed: {
    computedClass () {
      return this.class;
    },
  },
  watch: {
    modelValue (isOpen) {
      if (isOpen && ! this.isOpen) {
        this.open();
      } else if (! isOpen && this.isOpen) {
        this.close();
      }
    },
  },
};
</script>
